@if (checkIsPlatformBrowser()){
    @if(!needIframe){
    <div class="relative">
        <video #videoPlayer
               [autoplay]="autoplay"
               [muted]="isMuted"
               [loop]="loop"
               (loadstart)="onVideoLoad(videoPlayer)"
               playsinline
               class="relative w-full h-64 md:h-96 object-cover">
            <source [src]="videoUrl" type="video/mp4">
            Your browser does not support HTML5 video.
        </video>
        <div class="absolute top-0 right-0 m-4 flex space-x-2">
            <!-- Mute/Unmute Button -->
            @if(showMuteButton){
                <button (click)="toggleMute()" class="bg-card text-normal p-2 rounded">
                    @if(isMuted){
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true">
                            <path d="M4 9v6h4l5 5V4L8 9H4z" />
                            <line x1="16" y1="4" x2="8" y2="20" stroke="currentColor" stroke-width="2" />
                        </svg>
                    } @else {
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true">
                            <path d="M4 9v6h4l5 5V4L8 9H4z" />
                        </svg>
                    }


                </button>
            }
            @if(showPlayButton){
                <button (click)="togglePlay()" class="bg-card text-normal p-2 rounded">
                    @if(isPlaying){
                        <svg  xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 9v6m4-6v6" />
                        </svg>
                    } @else {
                        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12H9m0 0l-3 3m3-3l-3-3" />
                        </svg>
                    }
                </button>
            }
        </div>
    </div>
    } @else {

        <iframe
                class="relative w-full h-64 md:h-96 object-cover"
                width="100%"
                [src]="safeVideoUrl"
                frameborder="0"
                allow="autoplay; fullscreen"
                allowfullscreen>
        </iframe>
    }
}
